var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-check';
                    var viewUrl = 'sprite.svg#view-icon-check';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-check#icon-check';
                            viewUrl = 'sprite.svg?icon-check#view-icon-check';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27.1 16.7',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };